export default "__VITE_ASSET__CRG7CHlT__"